import { useNavigate } from 'react-router-dom'

export default function RefundSpouseMultipleIncome({ setShowSpouseIncome }) {
  const navigate = useNavigate()

  return (
    <div className='w-full flex flex-col items-center overflow-y-auto h-[90vh] justify-center'>
      <div className='max-w-lg max-sm:w-11/12 flex flex-col items-center shadow-lg rounded-md p-8 gap-4'>
        <p className='text-lg font-semibold text-center'>Spouse Income</p>
        <p className='text-center'>Based on your 2021 Tax Transcripts, we have detected that your spouse had SE Income.</p>
        <p className='text-center'>Would you like for your spouse to also apply for the SETC Tax Credit?</p>
        <div className='flex justify-center w-full gap-4'>
          <button onClick={() => navigate('/spouseCalculation')} className='px-8 py-2 text-white rounded bg-primaryColor hover:bg-primaryDarkColor transition duration-200'>
            Yes
          </button>
          <button onClick={() => setShowSpouseIncome(false)} className='px-8 py-2 text-white rounded bg-red-500 hover:bg-red-600 transition duration-200'>
            No
          </button>
        </div>
      </div>
    </div>
  )
}